import ContentPreview from 'components/messagePreview/components/ContentPreview';
import SuggestedActionsPreview from 'components/messagePreview/components/SuggestedActionsPreview';
import { MessageDirection } from 'components/messagePreview/types';
import { RcsMessage } from 'types/rcs';

interface RcsTextPreviewProps {
  direction?: MessageDirection;
  isLoading: boolean;
  message: RcsMessage;
  /** If true, the preview will not be interactive */
  inert?: boolean;
}

const RcsTextPreview = ({
  direction,
  isLoading,
  message,
  inert,
}: RcsTextPreviewProps) => {
  return (
    <>
      <ContentPreview
        contentPreview={isLoading ? 'Loading...' : message.content}
        direction={direction}
      />
      <SuggestedActionsPreview
        suggestedActions={message.suggestedActions}
        inert={inert}
      />
    </>
  );
};

export default RcsTextPreview;
